const FiltersStruct = {
  platforms: [],
  assignee: [],
  shops: [],
  countries: [],
  date: {},
  tags: [],
};
export { FiltersStruct as default };
